import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { SyncInsuranceAction } from '@typesApp/SyncListener'
import { syncInsuranceListenersSelector } from '@redux/slices/insuranceMemberSlice'

type InvokerFunction = (action: SyncInsuranceAction) => Promise<void>

export const useInvokeSyncInsuranceListeners = (): InvokerFunction => {
  const listenerList = useSelector(syncInsuranceListenersSelector)

  const invokeListeners = useCallback(
    (action: SyncInsuranceAction): Promise<void> => {
      return new Promise(resolve => {
        const listeners = listenerList?.listeners ?? []
        listeners.length &&
          console.debug('Invoking %s sync insurance listener(s) with action %s', listeners.length, action)

        try {
          listeners.forEach(handler => typeof handler === 'function' && handler(action))
        } catch (error) {
          console.warn('Error invoking sync insurance listener', error)
        } finally {
          resolve()
        }
      })
    },
    [listenerList]
  )

  return invokeListeners
}
